export default __webpack_public_path__ + "static/media/creneau.d829b15c.png";